import swal from 'sweetalert2'
import { formatWeight } from './weightDisplay'
import { TEXTS } from './cookedWeightsConstants'
import { WEIGHT_LEVEL, classifyWeight } from './weightLevel'

const DIALOG_TYPE = {
  [WEIGHT_LEVEL.NORMAL]: 'question',
  [WEIGHT_LEVEL.HIGH]: 'warning',
  [WEIGHT_LEVEL.IMPOSSIBLE]: 'error'
}

function describeWeight (level, grams) {
  const value = `<div class="weight-confirmation-value">${TEXTS.ENTERED_WEIGHT} ${formatWeight(grams)}</div>`
  if (level === WEIGHT_LEVEL.IMPOSSIBLE) {
    return `${value}<p class="mt-3">${TEXTS.IMPOSSIBLE_WEIGHT}</p>`
  }
  const warning = level === WEIGHT_LEVEL.HIGH
    ? `<p class="weight-confirmation-warning mt-3">${TEXTS.MORE_THAN_DOUBLE_MINIMUM}</p>`
    : ''
  return `${value}${warning}<p class="mt-3">${TEXTS.CONFIRM_WEIGHT_QUESTION}</p>`
}

export function confirmWeight (grams, minimumGrams) {
  const level = classifyWeight(grams, minimumGrams)
  const canConfirm = level !== WEIGHT_LEVEL.IMPOSSIBLE
  return swal({
    html: describeWeight(level, grams),
    type: DIALOG_TYPE[level],
    showCancelButton: canConfirm,
    confirmButtonClass: 'btn btn-success btn-fill',
    cancelButtonClass: 'btn btn-secondary btn-fill',
    confirmButtonText: canConfirm ? TEXTS.CONFIRM_WEIGHT_YES : TEXTS.CONFIRM_WEIGHT_NO,
    cancelButtonText: TEXTS.CONFIRM_WEIGHT_NO,
    buttonsStyling: false
  }).then((result) => canConfirm && Boolean(result && result.value))
}

export function dismissWeightConfirmation () {
  if (swal.isVisible()) {
    swal.close()
  }
}
